import { isFuture } from 'date-fns';

interface ContentWithExpiry<T = any> {
  content: T;
  expiryDate: string;
}

const DEFAULT_EXPIRY_HOURS = 48;

const createExpiryDate = (hoursFromNow: number) => {
  const currentTime = new Date();
  currentTime.setHours(currentTime.getHours() + hoursFromNow);
  return currentTime.toISOString();
};

const addExpiryDate = <T>(
  content: T,
  expiryInHours: number
): ContentWithExpiry<T> => {
  const expiryDate = createExpiryDate(expiryInHours);
  return {
    expiryDate,
    content,
  };
};

const isContentWithinExpiry = (content: ContentWithExpiry) => {
  if (content && isFuture(new Date(content.expiryDate))) return true;
  return false;
};

export const storeInLocalStorage = <T>(
  content: T,
  resourceKey: string,
  expiryInHours: number = DEFAULT_EXPIRY_HOURS
) => {
  const contentWithExpiry = addExpiryDate(content, expiryInHours);
  const dataToCache = JSON.stringify(contentWithExpiry);
  window.localStorage.setItem(resourceKey, dataToCache);
};

export const getItemFromLocalStorage = <T = any>(item: string): T | null => {
  const contentAsString = window.localStorage.getItem(item);
  if (!contentAsString) {
    return null;
  }
  const parsedContent: ContentWithExpiry<T> = JSON.parse(contentAsString);
  if (isContentWithinExpiry(parsedContent)) {
    return parsedContent.content;
  }

  return null;
};
